import  React from 'react';
// import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Parallax, Background } from "react-parallax";
import Fade from 'react-reveal/Fade'
import LogoBar from '../partials/logo-bar'
import ContactForm from '../partials/contact-form'
import ProjectOverview from '../partials/project-overviews';

const Home = ({ bio, data }) => {
    
    return (
        <>
            <LogoBar />
            <main id="home">
                <section className="landing full-height">
                    <span className="bg-text bg-text--right">About</span>
                    <div className="signature-container">
                        <img src="./img/_branding/signature.gif" className="signature" alt="hi"/>
                    </div>
                    <div className="bg-stripe bg-stripe--right bg-stripe--home" />
                    <div className="container">
                        <div className="landing__content-wrapper">
                            <div className="landing__bio" dangerouslySetInnerHTML={{ __html: bio }}/>
                        </div>
                        <div className="scroll-indicator-container">
                            <div className="scroll-indicator"></div>
                            <span>Scroll</span>
                        </div>
                    </div>
                </section>
                <section className="projects">
                    <div className="bg-stripe bg-stripe--left bg-stripe--projects" />
                    <Parallax strength={1000}>
                        <div className="container">
                            {data.map((project, key) => (
                                <Fade bottom key={key}>
                                    <ProjectOverview 
                                        slug={project.slug} 
                                        project={project.home} 
                                        id={key} 
                                    />
                                </Fade>
                            ))}
                        </div>
                        <Background>
                            <div className="projects__bg-text-container">
                                <span className="bg-text bg-text--left">Projects</span>  
                            </div>
                        </Background>
                    </Parallax>
                </section>
                <section className="contact full-height" id="contact">
                    <span className="bg-text bg-text--right">Contact</span>
                    <div className="bg-stripe bg-stripe--right bg-stripe--contact" />
                    <div className="container">
                        <div className="container">
                            <div className="description">
                                <h1>Get in touch</h1>
                            </div>
                            <ContactForm />
                        </div>
                    </div>
                </section>
            </main>
        </>
    )
}

export default withRouter(Home)